(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[568],{

/***/ 4836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export options */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2426);
/* harmony import */ var _components_article_card_article_card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(502);
/* harmony import */ var _articles_carousel_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7392);
/* harmony import */ var _articles_carousel_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_articles_carousel_module_scss__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var options = {
    slidesPerView: "auto",
    spaceBetween: 24,
    allowTouchMove: true,
    noSwiping: false,
    freeMode: true,
    breakpoints: {
        992: {
            watchOverflow: true
        }
    }
};
var ArticlesCarousel = function(param) {
    var articles = param.articles, ArticleCardProps = param.ArticleCardProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_articles_carousel_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_articles_carousel_module_scss__WEBPACK_IMPORTED_MODULE_3___default().box),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, _objectSpread({}, options, {
                children: articles.map(function(article) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_articles_carousel_module_scss__WEBPACK_IMPORTED_MODULE_3___default().item),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_article_card_article_card__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
                                dark: true,
                                article: article
                            }, ArticleCardProps), article.id || Math.random())
                        })
                    }, article.id);
                })
            }))
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticlesCarousel);


/***/ }),

/***/ 8568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9113);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(315);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5102);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2991);
/* harmony import */ var _components_articles_carousel_articles_carousel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4836);
/* harmony import */ var _utils_Article__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5269);
/* harmony import */ var _roomstay_blog_featured_articles_builder_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8447);
/* harmony import */ var _roomstay_blog_featured_articles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3867);
/* harmony import */ var _roomstay_blog_featured_articles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_roomstay_blog_featured_articles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








var RoomstayBlogFeaturedArticles = function(props) {
    var ref;
    var articlesProps = props.articles, builderState = props.builderState;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)((builderState === null || builderState === void 0 ? void 0 : (ref = builderState.state) === null || ref === void 0 ? void 0 : ref[_roomstay_blog_featured_articles_builder_component__WEBPACK_IMPORTED_MODULE_6__.RoomstayBlogFeaturedArticlesConfig.name].fixedArticles) || []), articles1 = ref1[0], setArticles = ref1[1];
    var getDataClientSide = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var articles;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,_utils_Article__WEBPACK_IMPORTED_MODULE_5__/* .getFeaturedArticles */ .L9)(articlesProps);
                    case 2:
                        articles = _ctx.sent;
                        setArticles(articles);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getDataClientSide() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (_builder_io_react__WEBPACK_IMPORTED_MODULE_2__/* .Builder.isEditing */ .Ib.isEditing) {
            getDataClientSide();
        }
    }, [
        articlesProps
    ]);
    if (!articles1 || !articles1.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_roomstay_blog_featured_articles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().root),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_roomstay_blog_featured_articles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().background)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_articles_carousel_articles_carousel__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                articles: articles1
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (RoomstayBlogFeaturedArticles);


/***/ }),

/***/ 7392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"articles-carousel_container__x82Kb","box":"articles-carousel_box__U6byE","item":"articles-carousel_item__mRGsi"};

/***/ }),

/***/ 3867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"roomstay-blog-featured-articles_root__T_jyv","background":"roomstay-blog-featured-articles_background__ZCzZa","slide":"roomstay-blog-featured-articles_slide__NWn_D","slider":"roomstay-blog-featured-articles_slider__pOk41"};

/***/ })

}]);